import { Link } from "react-router-dom";

import ProductCard from "../product-card/product-card.component";

import "./category-preview.styles.scss";

const CategoryPreview = ({ title, products }) => {
  return (
    <div className="category-preview-container">
      <h2>
        <Link className="title" to={title}>
          {title.toUpperCase()}
        </Link>
      </h2>
      <div className="preview">
        {
          // We want to filter out the products to only return product with index less than 4
          // Then map the product to the ProductCard
          products
            .filter((_, index) => index < 4)
            .map((product) => (
              <ProductCard product={product} />
            ))
        }
      </div>
    </div>
  );
};

export default CategoryPreview;
